import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { RenderField, RenderDatePicker, RenderTextareaField, RenderSubmitButton } from '../../common/form';
import * as Validations from '../../common/form/commonValidations';
import { createTask, fetchChecklist } from '../../../actions/ChecklistActions';

const AddTaskForm = ({ handleSubmit, pristine, submitting, valid }) => (
  <div>
    <div className="modal-header">
      <h3 className="modal-title">Add Task</h3>
    </div>
    <div className="modal-body">
      <form onSubmit={handleSubmit}>
        <Field
          name="title"
          type="text"
          id="checklist-task-title"
          component={RenderField}
          validate={Validations.REQUIRED}
          label="Task Title"
          placeholder="Send DJ our playlist"
          required
        />
        <Field
          name="due_at"
          type="date"
          id="checklist-task-due-at"
          component={RenderDatePicker}
          validate={[Validations.REQUIRED, Validations.DATE]}
          label="Due Date"
          required
        />
        <Field
          component={RenderTextareaField}
          name="notes"
          label="Note To Self"
          placeholder="Send as an attachment to dj@gmail.com."
          id="checklist-task-notes"
          rows={4}
        />
        <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} />
      </form>
    </div>
  </div>
);

AddTaskForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired
};

const mapDispatchToProps = (dispatch, ownProps) => (
  {
    onSubmit: createTaskRequest => dispatch(createTask(createTaskRequest)).then(() => {
      ownProps.hideModalFn();
      dispatch(fetchChecklist());
    })
  }
);

export default connect(
  null,
  mapDispatchToProps
)(reduxForm({
  form: 'AddTaskForm'
})(AddTaskForm));



// WEBPACK FOOTER //
// ./src/components/manage/checklist/AddTaskForm.jsx